import { expensesService, expenseGroupingsService, expenseTypesService, paymentTypesService, providersService } from "services";

export const getAllExpenses = (options) => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try {
		const list = await expensesService.getAll(options);

		dispatch({
			type: 'GET_EXPENSES',
			payload: list.data
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
	}
}

export const getAllExpenseTypes = (options) => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try {
		const list = await expenseTypesService.getAll(options);

		dispatch({
			type: 'GET_EXPENSE_TYPES',
			payload: list.data
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
	}
}

export const getAllExpenseGroupings = (options) => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try {
		const list = await expenseGroupingsService.getAll(options);

		dispatch({
			type: 'GET_EXPENSE_GROUPINGS',
			payload: list.data
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
	}
}

export const getAllExpenseStatus = () => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try {
		const list = await expensesService.getAllStatus();
		console.log(list);
		dispatch({
			type: 'GET_EXPENSE_STATUS',
			payload: list
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
	}
}

export const getAllPaymentTypes = (options) => async (dispatch) => {

	dispatch({
		type: 'LOADING'
	});

	try {
		const list = await paymentTypesService.getAll(options);

		dispatch({
			type: 'GET_PAYMENT_TYPES',
			payload: list.data
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
	}
}

export const getAllProviders = (options) => async (dispatch) => {

	try {
		const list = await providersService.getAll(options);

		dispatch({
			type: 'GET_PROVIDERS',
			payload: list.data
		});
	}
	catch (error) {
		console.log('Error: ' + error.message);
		dispatch({
			type: 'ERROR',
			payload: error.message
		});
	}
}

